

























































































import Vue from "vue";
import dayjs from "dayjs";
import ModalCampaignActivate from "@/components/campaign/ModalCampaignActivate.vue";
import StepperCreate from "@/components/campaign/StepperCreate.vue";
import { Campaign, CampaignAudienceType, CampaignStatus } from "../models";
import { validateCampaignSteps } from "@/rules/campaign.rules";
import CampaignService from "@/services/CampaignService";
export default Vue.extend({
  props: {
    campaign: {
      type: Object,
    },
  },
  components: { ModalCampaignActivate, StepperCreate },
  data() {
    return {
      newCampaign:
        this.campaign && (this as any).initializeCampaign(this.campaign),
      showDialog: false,
      valid: false,
      saveLoading: false,
      activateLoading: false,
      isInvalid: false,
    };
  },
  async mounted() {
    if (!this.campaign || !this.campaign.objectId) {
      // treatment to reload of the page
      if (this.$route.params.id) {
        // when is edit
        const campaign = await this.$store.dispatch(
          "loadCapaignById",
          this.$route.params.id
        );
        this.newCampaign = this.initializeCampaign(
          CampaignService.extractDuplicatableFields(campaign)
        );
      } else if (this.$route.query.id) {
        // when is duplicate
        const campaign = await this.$store.dispatch(
          "loadCapaignById",
          this.$route.query.id
        );
        this.newCampaign = this.initializeCampaign({
          ...CampaignService.extractDuplicatableFields(campaign),
        } as any);
      } else if (this.$route.query.draftId) {
        // when is from create button
        const campaign = await this.$store.dispatch(
          "loadCapaignById",
          this.$route.query.draftId
        );
        this.newCampaign = this.initializeCampaign({
          objectId: campaign.objectId,
          ...CampaignService.extractDuplicatableFields(campaign),
        } as any);
      }
    }
    if (!this.campaign.audienceFile) {
      window.localStorage.removeItem("@csv-array");
    }
    this.$store.dispatch("loadTeams");
  },
  computed: {
    isFormValid(): any {
      if (this.isInvalid) {
        return false;
      }
      if (!(this as any).newCampaign) {
        return false;
      }
      return (
        Object.values(validateCampaignSteps((this as any).newCampaign)).find(
          (v) => v !== true
        ) === undefined
      );
    },
  },
  methods: {
    initializeCampaign(campaign: any) {
      if (campaign) {
        Object.keys(campaign).forEach((key) =>
          campaign[key] === undefined ? delete campaign[key] : ""
        ); // remove undefined values
      }
      return {
        audienceType: CampaignAudienceType.File,
        audienceFileTokenMapping: [],
        scheduledTo: {
          __type: "Date",
          iso: new Date().toISOString(),
        },
        ...campaign,
      };
    },
    async openActivateModal() {
      const isEdit = !!(this as any).newCampaign.objectId;
      try {
        await this.calcCounters();
        this.showDialog = true;
      } catch (error) {
        this.$store.commit("addSnackbar", {
          text: `Erro ao ${(isEdit && "editar") || "criar"} campanha: ${
            error.message
          }`,
        });
      }
    },
    async calcCounters() {
      const { audienceBlobFile, ...newObject } = this.newCampaign as any;
      if (
        audienceBlobFile &&
        newObject.audienceType === CampaignAudienceType.File
      ) {
        const item = localStorage.getItem("@csv-array");
        const count = JSON.parse(item).length;
        newObject.audienceCount = count - 1;
        newObject.smsCount = count - 1;
      }
      if (newObject.audienceType === CampaignAudienceType.List) {
        const { audienceCount, smsCount } =
          CampaignService.extractAudienceCountAndSMSCountFromList(newObject);
        newObject.audienceCount = audienceCount;
        newObject.smsCount = smsCount;
      }
      this.newCampaign = newObject;
    },
    async onSave(activate?: boolean) {
      const isEdit = !!this.newCampaign.objectId || this.$route.params.id;
      this.activateLoading = !!activate;
      this.saveLoading = !activate;
      try {
        if (
          !this.newCampaign.smsCount ||
          !this.newCampaign.audienceCount ||
          this.newCampaign.audienceBlobFile
        ) {
          await this.calcCounters();
        }
        (this as any).newCampaign.status =
          CampaignStatus.Draft && activate
            ? CampaignStatus.Schedulled
            : CampaignStatus.Draft;
        if (this.$route.query.id) {
          // is from duplicate
          await this.$store.dispatch("createCampaign", this.newCampaign);
        } else {
          await this.$store.dispatch("updateCampaign", {
            ...this.newCampaign,
            objectId: this.newCampaign.objectId || this.$route.params.id,
          });
        }
        this.$router.push("/campaign");
        this.$store.commit("addSnackbar", {
          text: `Campanha ${(isEdit && "editada") || "criada"} com sucesso`,
          color: "success",
        });
      } catch (error) {
        this.$store.commit("addSnackbar", {
          text: `Erro ao ${(isEdit && "editar") || "criar"} campanha: ${
            error.message
          }`,
        });
      }
      this.saveLoading = false;
      this.activateLoading = false;
    },
    async closeDialog(activate: boolean) {
      this.showDialog = false;
      if (activate) {
        await this.onSave(activate);
      }
    },
  },
});
